import { c as _c } from "react/compiler-runtime";
import { cn } from "@domainstack/ui/utils";

/**
 * Parenthesized relative time that is safe to SSR.
 *
 * Relative copy needs a client clock (`useHydratedNow`). Until that clock
 * exists, this renders an invisible `()` around a `<time dateTime>` so the
 * layout and machine-readable instant stay in the HTML without a fake
 * "loading" label. Invalid dates render nothing.
 *
 * `suppressHydrationWarning` is required on both the wrapper (class/ARIA
 * change) and the `<time>` (text change). The warning only covers one
 * level, and the shared clock can flip during a long hydration pass.
 */
export function RelativeTimeSuffix(t0) {
  const $ = _c(10);
  const {
    dateTime,
    text,
    className
  } = t0;
  if (!dateTime) {
    return null;
  }
  const t1 = !text && "invisible";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cn(t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !text || undefined;
  let t4;
  if ($[3] !== dateTime || $[4] !== text) {
    t4 = <time dateTime={dateTime} suppressHydrationWarning={true}>{text}</time>;
    $[3] = dateTime;
    $[4] = text;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <span className={t2} aria-hidden={t3} suppressHydrationWarning={true}>{"("}{t4}{")"}</span>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}